import React from "react"
import Guide from "../base-pages/guide"

const GuideEN = () => {
  return <Guide lang="en" />
}

export default GuideEN
